import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';
import { createSystemUserPolicy } from './createSystemUser';

export const createPartnerUserPolicy = (grants: GrantsType) =>
  createSystemUserPolicy(grants) ||
  hasScopedPermission(grants, 'partner', 'portal_users.create');
